import * as z from 'zod';

export const TagSchema = z.object({
  id: z.union([z.number(), z.string()]).nullish().optional(),
  name: z.string(),
});

export type ITag = z.infer<typeof TagSchema>;
